<template>
  <list-page-layout class="lease-list-page" :pageSize="pageSize" :currentPage="pageIndex" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">保证金支出报表</span>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="订单类型">
        <el-select class="form-input" v-model="Search.OrderType" filterable placeholder="请选择或输入订单类型" clearable  @keyup.enter.native="handleSearch" clearable>
          <el-option label="充值押金" value="充值押金"></el-option>
          <el-option label="订单押金" value="订单押金"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间段">
        <el-date-picker
          v-model="Search.OrderDateDuration"
          type="daterange"
          align="right"
          placeholder="选择日期范围" @keyup.enter.native="handleSearch"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSearch" :loading="IsLoading" type="primary">查询</el-button>
      </el-form-item>
      <el-button @click="handleDoload" type="info" class="download">下载</el-button>
    </el-form>
    <div class="tab" slot="tabs">
      <el-row type="flex" justify="end">
        <el-col class="green" :span="3">总额：{{Received | amount}}</el-col>
        <el-col :span="3">支出：<span class="status">{{Paid | amount}}</span></el-col>
        <el-col class="green" :span="2.5">余额：{{Balance | amount}}</el-col>
      </el-row>
    </div>
    <template slot="main-content">
    <el-table
      v-loading="IsLoading"
      element-loading-text="加载中"
      :data="List"
      style="width: 100%">
      <el-table-column
        label="日期"
        width="180">
        <template scope="scope">
          <span>{{scope.row.CreateOn | date('YYYY-MM-DD HH:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Code"
        label="流水号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型">
        <template scope="scope">
          <span>订单来源：
            <el-button type="text" size="small">{{scope.row.Type}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Amount"
        label="金额">
        <template scope="scope">
          <span class="status" v-if= "scope.row.Amount > 0">{{scope.row.Amount | amount}}</span>
          <span class="green" v-if= "scope.row.Amount < 0">{{scope.row.Amount | amount}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Balance"
        label="保证金余额">
        <template scope="scope">
          <span class="status" v-if= "scope.row.Balance > 0">{{scope.row.Balance | amount}}</span>
          <span class="green" v-if= "scope.row.Balance < 0">{{scope.row.Balance | amount}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remark"
        label="说明">
      </el-table-column>
      <el-table-column
      label="操作"
      width="100">
      <template scope="scope">
        <el-button @click="goto({name: 'DepositDetail', params: {id: scope.row.ID}})" type="text" size="small">查看</el-button>
      </template>
    </el-table-column>
    </el-table>
  </template>
  </list-page-layout>
</template>

<script>
import ListPageLayout from '@/components/common/ListPageLayout'
import o from '@/odata'
export default {
  data() {
    return {
      Search: {
        OrderType: null,
        OrderDateDuration: null,
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近6个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近9个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 270)
            picker.$emit('pick', [start, end])
          },
        }, {
          text: '最近12个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          },
        }],
      },
      IsLoading: false,
      tableData: null,
      List: null,
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      Received: null,
      Paid: null,
      Balance: null,
      listURL: process.env.API_HOST + '/finance/RentalOrder/Deposit/Report',
    }
  },
  methods: {
    goto(params) {
      this.$router.push(params)
    },
    handleDoload() {
    },
    handleChange(params) {
      console.log(params)
      this.pageIndex = params
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    initTotal() {
      o(`Partner/Services.GetCurrentCustomer()`).get().then(({ data }) => {
        let CustomerCode = data.CustomerCode
        let URL = process.env.API_HOST + '/finance/RentalOrder/Deposit/Total?code=' + CustomerCode
        console.log(URL)
        this.$http.get(URL).then((response) => {
          console.log(response.data)
          this.Received = response.data.Received
          this.Paid = response.data.Paid
          this.Balance = response.data.Balance
        }).catch((response) => {})
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    handleSearch() {
      this.IsLoading = true
      let filters = ''
      if (this.Search.OrderType) {
        filters += '&input.type=' + this.Search.OrderType
      }
      if (this.Search.OrderDateDuration) {
        if (this.Search.OrderDateDuration[0] === null) {
          this.Search.OrderDateDuration === []
        } else {
          const startDate = this.$moment(this.Search.OrderDateDuration[0]).utc().add(1, 'd').set({hour: 0, minute: 0, second: 0}).format()
          const endDate = this.$moment(this.Search.OrderDateDuration[1]).utc().add(2, 'd').set({hour: 0, minute: 0, second: 0}).add(-1, 's').format()
          filters += '&input.minCreateOn=' + startDate
          filters += '&input.maxCreateOn=' + endDate
        }
      }
      // filters.join('&')
      const user = JSON.parse(window.localStorage.getItem('CURRENT_USER'))
      let URL = this.listURL + '?input.customer=' + user.userName + '&input.pageSize=' + this.pageSize + '&input.pageIndex=' + this.pageIndex + filters
      // console.log(URL)
      this.$http.get(URL).then((response) => {
        this.tableData = response.data
        this.List = this.tableData.List
        this.PageSize = this.tableData.PageSize
        this.total = this.tableData.Total
        this.IsLoading = false
      }).catch((response) => {
        this.IsLoading = false
      })
    },
  },
  components: {
    ListPageLayout,
  },
  created() {
    this.handleSearch()
    this.initTotal()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.status{
  color: red;
}
.green{
  color: green;
}
.tab{
  padding:10px;
}
.download{
  position: absolute;
  top: -70px;
  right: 20px;
}
.chose-days{
  width: 300px;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// Deposit_statement.vue?50ec67be